import React from 'react';
import { motion } from 'framer-motion';
import { TeamMemberCard } from './TeamMemberCard';
import { TeamMember } from './types';

interface TeamGridProps {
  members: TeamMember[];
  inView: boolean;
}

export function TeamGrid({ members, inView }: TeamGridProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.6 }}
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {members.map((member) => (
          <div key={member.name} className="relative">
            <TeamMemberCard member={member} />
          </div>
        ))}
      </div>
    </motion.div>
  );
}
